import React from 'react';
import { StyledAppBar } from './styled';
export const AppBar = ({ children, ...props }) => (React.createElement(StyledAppBar, { ...props }, children));
